import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { CameraSettings, DvrSettings } from '@fc-store/model/dvr-settings';
import { loadAllRequestsInOne } from '@fc-core/services/load-all-requests';

@Injectable({
  providedIn: 'root',
})
export class DvrSettingsService {
  constructor(private httpClient: HttpClient) {}

  getDvrSettings(): Observable<DvrSettings[]> {
    return loadAllRequestsInOne<DvrSettings>(
      `${environment.apiUrl}api/dvr/settings/`,
      this.httpClient,
    ).pipe(map((res) => res.list));
  }

  getDvrSettingsById(cameraId: number): Observable<DvrSettings> {
    return this.httpClient.get<DvrSettings>(
      `${environment.apiUrl}api/dvr/settings/${cameraId}/`,
    );
  }

  updateManyCameraSettings(
    settings: CameraSettings,
    cameraIds: number[],
  ): Observable<DvrSettings[]> {
    const requests = cameraIds.map((cameraId) =>
      this.updateCameraSettings(settings, cameraId),
    );
    return forkJoin(requests);
  }

  updateCameraSettings(
    settings: CameraSettings,
    cameraId: number,
  ): Observable<DvrSettings> {
    return this.httpClient.put<DvrSettings>(
      `${environment.apiUrl}api/dvr/settings/${cameraId}/`,
      settings,
    );
  }
}
